import { ref, getCurrentInstance } from '@vue/composition-api';
import { useDebounceFn } from '@vueuse/core';

const useCount = (initialValue = 1) => {
  if (!initialValue) {
    throw new Error('initialValue должно быть положительным, целым числом');
  }

  const { emit } = getCurrentInstance();

  const count = ref(initialValue);

  const handlerChangeCount = useDebounceFn((value) => {
    if (count.value !== value) {
      count.value = value;
      emit('changeCount', value);
    }
  }, 500);

  return {
    count,
    handlerChangeCount,
  };
};

export default useCount;
